import React from "react";
import { jsOpenShareDialog, jsOpenPage } from "@/utils/bridge";
import { reportClick, reportPop, reportPopClick } from "@/utils/report";
import { setShareConfig } from "@/utils/share";
import styles from "@/css/result.module.less";

const REPORT_DATA = {
  page_name: "page:result",
};

const SHARE_PLATFORM_MAP = {
  0: "wechat_friend",
  1: "wechat_moments",
  5: "copy_link",
  "-1": "cancel",
};

const testSpeedAgain = () => {
  console.log("调用原生方法，再试一次");
  reportClick({
    ...REPORT_DATA,
    button_name: "test_again",
  });
  jsOpenPage({
    url: "page:home?index=0&autoStart=true",
  });
};

const shareTestResult = (info) => {
  console.log("调用原生方法，进行分享");
  const { percent, speedId } = info;
  const share_config = setShareConfig({
    share_link: `${window.location.origin}/app-result/${speedId}?from=share`,
    percent,
  });
  reportClick({
    ...REPORT_DATA,
    button_name: "share_btn",
  });
  reportPop({
    ...REPORT_DATA,
    pop_name: "share_pop",
  });
  jsOpenShareDialog(share_config, (res) => shareEventCallback(res, speedId));
};

const shareEventCallback = (res, speedId) => {
  console.log("share res: ", res);
  if (res && res.code === 0) {
    const { platform } = res.data;
    reportPopClick({
      ...REPORT_DATA,
      pop_name: "share_pop",
      button_name: SHARE_PLATFORM_MAP[platform],
      speed_id: speedId,
      method: SHARE_PLATFORM_MAP[platform],
    });
  }
};

const BottomCard = ({ from, info, clickCallback }) => {
  const isFromShare = from === "share";
  // const isFromSpeed = from === "speed";
  const { downloadQrcode } = info;
  return (
    <div className={styles["bottom-card-wrapper"]}>
      <div className={styles["bottom-content-h5"]}>
        {!isFromShare && (
          <>
            <p className={styles["bottom-slogan"]}>再试一次，数据会更准哦！</p>
            <button
              className={`${styles["result-btn"]} ${styles["fill-btn"]}`}
              onClick={testSpeedAgain}
            >
              再测一次
            </button>
            <button
              className={`${styles["result-btn"]} ${styles["line-btn"]}`}
              onClick={() => shareTestResult(info)}
            >
              炫耀一下
            </button>
          </>
        )}
        {isFromShare && (
          <button
            className={`${styles["result-btn"]} ${styles["fill-btn"]}`}
            onClick={clickCallback}
          >
            我也测一测
          </button>
        )}
      </div>
      {/* <div className={styles["bottom-content-pc"]}>
        <p className={styles["bottom-slogan-pc"]}>
          浏览器会影响测速精度，扫码下载星域测速APP，体验更精准测速、5G测速！
        </p>
        <ul className={styles["bottom-info-wrapper"]}>
          <li className={styles["bottom-info-item"]}>
            <img
              src={downloadQrcode}
              alt="qrcode"
              className={styles["bottom-qrcode"]}
            />
          </li>
          <li className={styles["bottom-info-item"]}>
            <i
              className={`${styles["bottom-icon"]} ${styles["icon-android"]}`}
            />
            <p>安卓版本</p>
          </li>
          <li className={styles["bottom-info-item"]}>
            <i className={`${styles["bottom-icon"]} ${styles["icon-ios"]}`} />
            <p>
              IOS版本<span>(敬请期待)</span>
            </p>
          </li>
        </ul>
      </div> */}
    </div>
  );
};
export default BottomCard;
